import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "faqs-section" };
const _hoisted_2 = { class: "faqs-container" };
const _hoisted_3 = ["onClick"];
const _hoisted_4 = { class: "question-text" };
const _hoisted_5 = {
    key: 0,
    class: "faq-answer"
};
const _hoisted_6 = { class: "external-icon" };
const _hoisted_7 = ["src"];
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
export default /*@__PURE__*/ _defineComponent({
    __name: 'FaqsSection',
    props: {
        faqs: {},
        limit: {},
        faqName: {}
    },
    setup(__props) {
        const props = __props;
        const router = useRouter();
        const expandedIndex = ref(null);
        const displayedFaqs = computed(() => {
            const faqs = props.faqs ?? [];
            if (props.limit) {
                return faqs.slice(0, props.limit);
            }
            return faqs;
        });
        function toggleFaq(index) {
            expandedIndex.value = expandedIndex.value === index ? null : index;
        }
        function goToAllFaqs() {
            const route = props.faqName ? `/faqs?name=${props.faqName}` : '/faqs';
            router.push(route);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "faqs-title" }, "For peace of mind....", -1)),
                _createElementVNode("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedFaqs.value, (faq, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "faq-item"
                        }, [
                            _createElementVNode("div", {
                                class: "faq-question",
                                onClick: ($event) => (toggleFaq(index))
                            }, [
                                _createElementVNode("span", _hoisted_4, _toDisplayString(faq.question), 1),
                                _createElementVNode("span", {
                                    class: _normalizeClass(["chevron", { expanded: expandedIndex.value === index }])
                                }, "›", 2)
                            ], 8, _hoisted_3),
                            _createVNode(_Transition, { name: "expand-answer" }, {
                                default: _withCtx(() => [
                                    (expandedIndex.value === index)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(faq.answer), 1))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 2
                            }, 1024)
                        ]));
                    }), 128))
                ]),
                (_ctx.limit != null)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "read-all-link",
                        onClick: goToAllFaqs
                    }, [
                        _cache[0] || (_cache[0] = _createElementVNode("span", null, "Read all FAQs", -1)),
                        _createElementVNode("span", _hoisted_6, [
                            _createElementVNode("img", {
                                src: require('@/assets/ExternalLink.png')
                            }, null, 8, _hoisted_7)
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
